import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TRACKING_VIEW } from '../Model/Models';
import { MODELS } from '../../../../Apis/Models';
import { TABLES } from '../../../../Apis/Tables';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetEquipmentDetailsById } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentMaterialModalApp = (props) => {
    const { item } = props;
    const { t } = useTranslation();
    const [criteria, setCriteria] = useState();
    const moduleId = `${MODELS.EQUIPMENT_ACCESS_LOG}`;
    const option = `${TABLES.EQUIPMENT_ACCESS_LOG}`;
    const [search, setSearch] = useState(false);
    const [subView, setSubView] = useState(TRACKING_VIEW.ACCESS_LOG);
    const [displayModal, setDisplayModal] = useState('');
    const equipment = useSelector((state) => state?.equipmentSlice?.equipmentDetailsById);
    const dispatch = useDispatch();

    const handleSubViewChange = (value) => {
        setSubView(value);
    };
    useEffect(() => {
        setDisplayModal('');
    }, []);

    useEffect(() => {
        dispatch(GetEquipmentDetailsById(item.id));
    }, []);

    return {
        t,
        subView,
        handleSubViewChange,
        setSubView,
        moduleId,
        criteria,
        search,
        option,
        setCriteria,
        displayModal,
        setDisplayModal,
        equipment,
    };
};

export default EquipmentMaterialModalApp;
